<template>
  <div class="hc-sidebar-container">
    <div class="logo-container" @click="goHome">
      <svg-icon style="width: 40px; height:40px" icon-class="logo" />
    </div>
    <YuMenus :menu-list="bjMenuList" v-if="isBjToken" />
    <div class="menu-container" v-else>
      <div v-for="(menu) in permissionMenus" @click="goPath(menu)" :key="menu.name" class="menu-item-container" :class="isActive(menu.name)?'active':''" @mouseover="mouseOver">
        <svg-icon class-name="icon-class icon-1" :icon-class="menu.meta.icon" />
        <svg-icon class-name="icon-class icon-hover" :icon-class="'hover-'+menu.meta.icon" />
        <span :class="['link-text', getLanguage === 'en' && 'link_text_en']">{{ menu.meta.title }}</span>
        <!-- <div class="active-bar" /> -->
        <div v-if="menu.children && menu.children.length" class="child-menu" :style="{left: childMenuLeft + 'px'}">
          <div class="level-one-title">{{ menu.meta.title }}</div>
          <sidebar-item :base-path="menu.path" :menu="menu" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import YuMenus from '@/components/yu-menus'
import SidebarItem from './SidebarItem.vue'
import { navigateToErpHome } from '@/services/microFeUtil/pageTagUtils'
export default {
  components: {
    SidebarItem,
    YuMenus
  },
  data() {
    return {
      currentMenuItemData: null,
      currentMenuItemIndex: -1,
      isBjToken: false,
      childMenuLeft: 59
    }
  },
  async created() {
    const tokenObj = this.$utils.getToken()
    if (tokenObj.xFrom === 1 || tokenObj.xFrom === 2) {
      this.isBjToken = true
    }
  },
  computed: {
    ...mapGetters([
      'permissionMenus',
      'bjMenuList'
    ]),
    getLanguage() {
      return this.$i18n.locale
    }
  },
  methods: {
    onMouseOver(menu, index) {
      this.currentMenuItemData = menu
      this.currentMenuItemIndex = index
    },
    onMouseOut() {
      this.currentMenuItemData = null
    },
    async goHome() {
      navigateToErpHome()
      // const tokenObj = this.$utils.getToken()
      // if (tokenObj.xFrom === 1) {
      //   const res = await this.$request(this.$api.login.fbaMenuUserApi)
      //   if (res.code === 200) {
      //     const fbaList = res.data
      //     if (fbaList.indexOf(this.$ls.get('sid')) !== -1) {
      //       this.$router.push({ name: 'home' })
      //       return
      //     }
      //   }
      //   location.href = this.$utils.getErpDomain()
      // } else {
      //   this.$router.push({ name: 'home' })
      // }
    },
    goPath(menu) {
      if (!menu.children) {
        this.$router.push(menu.path)
      }
    },
    isActive(name) {
      return name === this.$route.matched[0].name || (name === 'bi-analysis' && this.$route.name === 'home')
    },
    mouseOver() {
      this.childMenuLeft = 59 - document.documentElement.scrollLeft
    }
  }
}
</script>

<style lang="scss" scoped>
.hc-sidebar-container {
  box-shadow: 0px -1px 0px 0px #e8e8ea;
  .logo-container {
    width: 100%;
    height: 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    .logo-img {
      width: 40px;
      height: 46px;
    }
    .logo-title {
      font-size: 14px;
      font-weight: 400;
      color: #000000;
      line-height: 20px;
      margin-top: 10px;
    }
  }
  .menu-container {
    width: 100%;
    height: calc(100% - 128px);
    .menu-item-container {
      width: 100%;
      height: 66px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      cursor: pointer;
      color: #c5c5c5;
      &.firstEle {
        margin-top: 0px;
      }
      .icon-class {
        font-size: 24px;
        color: #c5c5c5;
        &.icon-1 {
          display: block;
        }
        &.icon-hover {
          display: none;
        }
      }
      .link-text {
        // color: $G7;
        color: #A0A7B8;
        font-size: 13px;
        font-weight: 600;
        line-height: 18px;
        margin-top: 4px;
      }
      .link_text_en {
        font-size: 12px !important;
      }
      .active-bar {
        visibility: hidden;
        position: absolute;
        right: 0;
        width: 3px;
        height: 44px;
        background-color: rgba($color: #3b6dff, $alpha: 0.8);
        border-radius: 44px 0px 0px 44px;
      }
      .child-menu {
        display: none;
        position: fixed;
        border-left: 1px solid $G3;
        left: 59px;
        top: 0;
        height: 100vh;
        width: 238px;
        background: #ffffff;
        box-shadow: 4px 2px 20px 0px rgba(0, 0, 0, 0.04);
        z-index: 9999;
        overflow-y: auto;
        padding: 40px 0 80px 0;
        cursor: default;
        .level-one-title {
          margin: 0 0 29px 32px;
          font-size: 18px;
          font-weight: 500;
          color: #313233;
        }
      }
      &:hover {
        background-color: rgba($color: #80B3FF, $alpha: 0.23);
        .active-bar {
          visibility: visible;
          display: none;
        }
        &.active {
          .active-bar {
            visibility: visible;
            display: block;
          }
        }
        .link-text {
          color: #ffffff;
        }
        .icon-class {
          color: #ffffff;
          &.icon-1 {
            display: none;
          }
          &.icon-hover {
            display: block;
          }
        }
        .child-menu {
          display: block;
        }
      }
      &.active {
        background-color: rgba($color: #80B3FF , $alpha: 0.23);
        .active-bar {
          visibility: visible;
        }
        .link-text {
          color: #ffffff;
        }
        .icon-class {
          color: #ffffff;
          &.icon-1 {
            display: none;
          }
          &.icon-hover {
            display: block;
          }
        }
      }
    }
  }

  @media screen and (max-height: 620px) {
    //窗口小于一定高度，左侧菜单栏的图标隐藏

    .menu-container {
      .menu-item-container {
        height: 40px;
        font-size: 14px;
        .active-bar {
          height: 40px;
        }
        .link-text {
          margin-bottom: 4px;
        }
        .icon-class.icon-1 {
          display: none;
        }
        &.active {
          .icon-class.icon-hover {
            display: none;
          }
        }
        &:hover {
          .icon-class.icon-hover {
            display: none;
          }
        }
      }
    }
  }
}
</style>
